import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { Text } from "../../components/text";

export const FAQOrders = () => {
  return (
    <>
      <FAQSectionTitle>
        Pesanan
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Apa yang dimaksud dengan konfirmasi pesanan diterima?
        </FAQButton>
        <FAQItem>
          <Text>
            Jika Anda sudah klik pesanan diterima maka status pesanan akan menjadi selesai yang artinya pesanan telah diterima dengan kondisi utuh dan lengkap tanpa komplain, sehingga Anda tidak dapat mengajukan komplain setelah klik pesanan diterima/ ketika pesanan berstatus selesai
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Apa yang harus saya lakukan jika ternyata pesanan saya memang belum diterima?
        </FAQButton>
        <FAQItem>
          <Text>
            Silakan cek resi dan lacak pesanan Anda, jika masih di perjalanan di luar waktu estimasi silahkan hubungi pihak ekspedisi
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Berapa lama waktu yang diberikan untuk konfirmasi pesanan diterima?
        </FAQButton>
        <FAQItem>
          <Text>
            Waktu yang diberikan sejak pesanan tiba di alamat tujuan ialah H+7 hari
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimanakah cara melacak pesanan saya? 
        </FAQButton>
        <FAQItem>
          <Text>
            Anda bisa klik “Lihat detail” di halaman rincian pesanan atau menyalin resi dan melakukan pelacakan di website masing-masing ekspedisi
          </Text>
        </FAQItem>
      </Disclosure>

      <Disclosure>
        <FAQButton>
          Bagaimana cara melacak pesanan dengan pengiriman lainnya (ACC, Rado, Baraka)?
        </FAQButton>
        <FAQItem>
          <Text>
            Anda tidak bisa melacak pesanan dengan pengiriman ini. Silahkan hubungi customer service Jooalan untuk minta bukti pengiriman dan anda bisa langsung menghubungi jasa pengiriman terpilih untuk pertanyaan terkait pengiriman
          </Text>
        </FAQItem>
      </Disclosure>
    </>
  )
}